import Vue from "vue";
import { MutationTree } from "vuex";
import { ITransporterState } from "./state";
import { ITransporter } from "@/models";
import {
    ADD_TRANSPORTERS,
    ADD_TRANSPORTER,
    CLEAN_TRANSPORTERS,
    ADD_ACTIVE_TRANSPORTERS,
    TOGGLE_TRANSPORTER,
} from "./mutations-types";

export const mutations: MutationTree<ITransporterState> = {
    [ADD_TRANSPORTERS](state, payload: ITransporter[]): void {
        state.transporters = state.transporters.concat(payload);
    },

    [ADD_ACTIVE_TRANSPORTERS](state, payload: ITransporter[]): void {
        state.activeTransporters = state.activeTransporters.concat(payload);
    },

    [CLEAN_TRANSPORTERS](state): void {
        state.transporters = [];
    },

    [ADD_TRANSPORTER](state, payload: ITransporter): void {
        state.transporters.push(payload);
        state.activeTransporters.push(payload);
    },

    [TOGGLE_TRANSPORTER](state, payload: ITransporter): void {
        // edit in transporters

        let index: number = state.transporters.findIndex(t => t.transporterId === payload.transporterId);
        Vue.set(state.transporters, index, payload);

        // edit in transportersActive (remove or add)
        index = state.activeTransporters.findIndex(t => t.transporterId === payload.transporterId);

        if (index > 0) {
            state.activeTransporters.splice(index, 1);
        }
        else {
            state.activeTransporters.push(payload);
        }

    },
};
